<style lang="less" scoped>
    .card {
        position: relative;
        display: inline-flex;
        align-items: center;
        width: 42%;
        /*width: 19%;*/
        height: 86px;
        background: rgba(255,255,255,1);
        border: 1px solid rgba(219,222,231,1);
        border-radius: 4px;
        padding: 0 2%;
        text-align: left;

        &-info {
            flex: 1;
            overflow: hidden;
        }

        &-line {
            &-top:before {
                position: absolute;
                top: -18px;
                left: 50%;
                content: '';
                display: flex;

                width: 1px;
                height: 17px;
                background-color: rgba(219,222,231,1);
            }

            &-bottom:after {
                position: absolute;
                bottom: -8px;
                left: 50%;
                content: '';
                display: flex;

                width: 1px;
                height: 8px;
                background-color: rgba(219,222,231,1);
            }

        }

        &-title {
            font-size: 12px;
            color: rgba(70,76,91,1);
        }

        &-value {
            width: 100%;
            /*width: 127px;*/
            height: 22px;
            line-height: 23px;
            font-size: 20px;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: rgba(70,76,91,1);

            margin-top: 8px;
            margin-bottom: 4px;
        }

        &-compare {
            &-box {
                display: flex;
                justify-content: space-between;
                align-items: center;

                &.flex-start {
                    justify-content: flex-start;
                }
            }
            display: inline-block;
            &-title {
                height: 17px;
                line-height: 17px;
                font-size: 12px;
                color: rgba(124,131,148,1);
            }

            &-value {
                height: 16px;
                line-height: 16px;
                font-size: 14px;

                &:before {
                    content: "";
                    display: inline-block;
                    margin: 0 2px 0 4px;
                    width: 8px;
                    height: 16px;
                    background-repeat: no-repeat;
                    background-size: contain;
                    vertical-align: middle;
                }

                &.up {
                   color: rgba(255,35,36,1);
                    &:before {
                        background-position: 0 3px;
                        background-image: url("//m.360buyimg.com/img/jfs/t1/130718/24/4027/140/5f05a8b4Edfc17adb/acca475fabf685f3.png");
                    }
                }

                &.down {
                    color: rgba(16,208,112,1);
                    &:before {
                        background-position: 0 3px;
                        background-image: url("//m.360buyimg.com/img/jfs/t1/130808/35/4009/338/5f05a8b4E541bae35/ebcb91fb3a9fc127.png");
                    }
                }
            }
        }

        &-ratio {
            display: inline-block;
            /*position: absolute;*/
            /*right: 11px;*/
            /*bottom: 5px;*/
            &-title {
                height: 8px;
                line-height: 8px;
                font-size: 12px;
                color: rgba(124,131,148,1);
            }

            &-value {
                height: 9px;
                line-height: 9px;
                font-size: 14px;
                color: rgba(70,76,91,1);
            }
        }

        &-chart {
            width: 54px;
            height: 54px;

            .pie {
                width: 100%;
                height: 100%;
            }
        }
    }
    .card-icon {
        display: inline-block;
        position: absolute;
        top: 38%;
        left: -12px;

        width: 8.75%;
        height: 27px;
        z-index: 2;

        &--result {
            background-repeat: no-repeat;
            background-size: contain;
            background-image: url("//m.360buyimg.com/img/jfs/t1/129699/7/4074/521/5f06b65cEecf79719/94f50fff29043528.png");
        }
    }
</style>

<template>
    <div :style="cardStyle" :class="['card', topline ? 'card-line-top':'', bottomline ? 'card-line-bottom' : '']">
        <div class="card-info">
            <div class="card-title">
                {{title || '-'}}
                <p-tooltip
                    v-show="carddata.tooltip"
                    placement="right-start"
                    trigger="hover">
                    <div slot="content" style="min-width:40px;white-space:break-spaces;">{{carddata.tooltip || ''}}</div>
                    <p-icon type="ios-help-outline" transfer="true"></p-icon>
                </p-tooltip>
            </div>
            <div class="card-value" :title="carddata.value">
                {{carddata.value || '-'}}
            </div>
            <div :class="['card-compare-box', {'flex-start': carddata.ratio === undefined}]">
            <div class="card-compare">
                <span class="card-compare-title">环比</span>
                <span :class="['card-compare-value', carddata.trend || '']">{{carddata.subValue || '-'}}</span>
            </div>
            <div class="card-ratio" v-show="carddata.ratio">
                <span class="card-ratio-title">利润率</span>
                <span class="card-ratio-value">{{carddata.ratio || '-'}}%</span>
            </div>
            </div>
        </div>
        <div class="card-chart" v-show="piedata.length">
            <div :id="chartName" class="pie"></div>
        </div>
        <i class="card-icon card-icon--result" v-show="resultVisible"></i>
    </div>
</template>

<script>
    // 引入 ECharts 主模块
    import echarts from 'echarts'

    let chartOptions = {
        tooltip: {
            width: '114px',
            height: '86px',
            backgroundColor: '#EDF6FF',
            textStyle: {
                color: '#000',
                lineHeight: 14,
                fontSize: 10
            },
            position: ['100%', '-17'],
            extraCssText: 'box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);opacity: 0.9;padding: 5px 16px;',
            // formatter: (parms) => {
            //     console.log("===", parms, this)
            //
            //     var str=
            //         parms.marker+""+parms.name + '\n\n\n\n' + parms.percent+" %";
            //     return  str ;
            // }
        },
        series: [{
            type: 'pie',
            radius: ['70%', '100%'],
            hoverAnimation: false,
            label: {
                show: false,
                position: 'center'
            },
            data: []
        }]
    }

    export default {
        name: "cause-card",
        props: {
            title: {
                type: String,
                default: '-'
            },
            carddata: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            piedata: {
                type: Array,
                default: function () {
                    return []
                }
            },
            topline: {
                type: Boolean,
                default: false
            },
            bottomline: {
                type: Boolean,
                default: false
            },
            chartName: {
                type: String,
                default: function () {
                    return `chart${Math.random()*10}`
                }
            },
            cardStyle: {
                type: Object
            },
            chartvisible: {
                type: Boolean,
                default: true
            },
            resultVisible: {
                type: Boolean,
                default: false
            },
            tooltip: {
                type: String
            }
        },
        data() {
            return {}
        },
        watch: {
            'piedata': {
                deep: true,
                // immediate: true,
                handler(newValue, oldValue) {
                    if (newValue && newValue.length) {
                        this.initChart()
                    }
                }
            }
        },
        ready() {},
        methods: {
            initChart() {
                var myChart = echarts.init(document.getElementById(this.chartName));
                chartOptions.series[0].data = this.carddata.pieData || []
                chartOptions.tooltip.formatter = this.formatter
                myChart.setOption(chartOptions);
                console.log("myChart==", myChart)
            },
            formatter(parmas) {
                let pieData = this.carddata.pieData
                var str = ''
                pieData.forEach((item) => {
                    str +=  '<div style="margin-top: 5px;height:14px;font-size: 10px;">' + parmas.marker.replace(/#(\w+)/, item.itemStyle.color)+ "" + item.name + ':\n\n\n\n' + item.data + '\n\n('+ item.value+"%)</div>";
                })
                return  str;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// card.vue?6f17e0c3